import React, {useReducer, useEffect, useRef, useContext } from "react";
import { getAllProveedores, addProveedor, updateProveedor, deleteProveedor, getProveedoresFromSoftland, getProveedorFromInf } from "../../api/proveedor.js";

import ProveedorContext from "./proveedorContext.js";
import ProveedoresReducer from "./proveedorReducer.js";
import { ACTUALIZAR_LIST_PROVEEDORES } from "./proveedorActions.js";
  
import authContext from "../authentication/authContex.js";
import { SocketContext } from "../socket/socket.js";

const ProveedorState = props =>{
     
    const initialState = {
        proveedoresList: null
    };
    const server = useContext(SocketContext);

    const [state, dispatch] = useReducer(ProveedoresReducer, initialState);
    const proveedoresRef = useRef(state.proveedoresList)

    const ahContext = useContext(authContext);
    const {usuario, verificarTenant} = ahContext;

    const actualizarProveedoresList = async () => {
        try{
            const resp = await getAllProveedores();
            const proveedor = resp.data.data;
            proveedoresRef.current = proveedor;
            dispatch({
                type: ACTUALIZAR_LIST_PROVEEDORES,
                payload: proveedor
            });
            return proveedor;
        }catch(err){
            console.log("err en actualizarProveedoresList")
            console.log(err)
        }
    };

    const actualizarProveedoresFromSoftland = async() =>{
        try {
            const resp = await getProveedoresFromSoftland();
            dispatch({
                type: ACTUALIZAR_LIST_PROVEEDORES,
                payload: [...resp.data.data]
            });
            return resp
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    const agregarProveedor = async (dato) => {
        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addproveedor
            const resp = await addProveedor(dato);
            const proveedor = resp.data.data;
            return proveedor;
        }catch(err){
            console.log(err);
            return null;
        }
    };

    const modificarProveedor = async (dato) => {
        try{
            const resp = await updateProveedor(dato._id, dato);
            const proveedor = resp.data.data;
            return proveedor;
        }catch(err){
            console.log(err)
        }
    }

    const eliminarProveedor = async (id) => {
        try{
            const resp = await deleteProveedor(id);
            const activo = resp.data.data;
            return activo;
        }catch(err){
            console.log(err)
        }
    }

    const getProveedorFromInforme = async(tDoc) => {
            try {
                // return {obtenidos:true, proveedores:[{nroCta:"00010",importe:555,nombre:"CHACOMA BALANZAS INDUSTRIALES S.A."},{nroCta:"00030", importe:666,nombre:"MOTORVIAL SUDESTE"}], msg:'Proveedores obtenidos exitosamente!'};
                const resp = await getProveedorFromInf(tDoc.tDocCodFor, tDoc.tDocNroFor);
                if(resp.status == 200 && resp.data.proveedores){
                    if(resp.data.proveedores.length > 0) return {proveedores:resp.data.proveedores, obtenidos: true, msg:'Proveedores obtenidos exitosamente!'}
                    else return {obtenidos: false, msg: 'No existen Informes de Recepción Reales asociados a la ODT'}
                }else{
                    return {obtenidos: false, msg: 'Hubo un error al comunicarse con el servidor'}
                }
            } catch (error) {
                console.log("error en getProveedorFromInforme");
                console.log(error);
                return {obtenidos: false, msg: error.response.data.message};
            }
        }

    useEffect(() => {
        if(usuario != null){
            actualizarProveedoresList();
        }
    },[usuario])

    useEffect(()=>{
         if(server){
            server.on('proveedorNew', ({tenantId}) =>{
                console.log("Recibo el evento del Real Time Server proveedorUpdated");
                const verification = verificarTenant(tenantId)
                if(verification){
                    actualizarProveedoresList();
                }
            })
            server.on('proveedorUpdated', ({tenantId,proveedorUpdated}) =>{
                console.log("Recibo el evento del Real Time Server proveedorUpdated");
                const verification = verificarTenant(tenantId)
                if(verification){
                    let newProveedores = proveedoresRef.current.map(l => l._id == proveedorUpdated._id ? proveedorUpdated : l);
                    proveedoresRef.current = newProveedores;
                    dispatch({
                        type: ACTUALIZAR_LIST_PROVEEDORES,
                        payload: newProveedores
                    });
                }
            })
            return () => {
                server.off('proveedorNew');
                server.off('proveedorUpdated');
            }
        }
    },[server])

    return(
        <ProveedorContext.Provider
            value={{
                proveedoresList: state.proveedoresList,
                actualizarProveedoresList,
                actualizarProveedoresFromSoftland,
                agregarProveedor,
                modificarProveedor,
                eliminarProveedor,
                getProveedorFromInforme
            }}
        >
            {props.children}
        </ProveedorContext.Provider>
    )

}

export default ProveedorState;